<template>
    <div class="product-review-item-wrapper"
         :class="{ 'product-review-item__answer': +result.UF_DEPTH_LEVEL > 0 }"
    >
        <ProductReviewAuthor :result="result" :messages="messages"/>
        <ProductReviewText :result="result" :messages="messages" :user="user" @openReviewModal="(data) => $emit('openReviewModal', data)"/>
    </div>

</template>

<script>
    import ProductReviewAuthor from "./ProductReviewAuthor.vue";
    import ProductReviewText from "./ProductReviewText.vue";

    export default {
        name: "ProductReviewItem",
        components: {ProductReviewText, ProductReviewAuthor},
        props: ['result', 'messages', 'user']
    }
</script>

<style lang="scss" scoped>
    .product-review-item-wrapper {
        display: flex;
        border-top: 1px solid #e0dbd5;
        padding: 10px 30px 10px 30px;
        //justify-content: space-between;
        gap: 15px;
        &__answer {
            margin-left: 35px;
        }

        @include point-lg {
            padding: 10px;
        }
    }
</style>